import { Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import { InvoicesFilter } from '@components/Billing/Invoices/InvoicesFilter';
import { InvoicesTable } from '@components/Billing/Invoices/InvoicesTable';
import { TotalUnbilledTraffic } from '@components/Dashboard';
import { billingApi } from '@reducers/billing';

export const Invoices = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isPrepaid } = useSelector((state) => state.auth.user);
  return (
    <>
      {!isPrepaid && (
        <Row className="mb-3">
          <Col md={6}>
            <TotalUnbilledTraffic />
          </Col>
        </Row>
      )}
      <Formik
        enableReinitialize
        initialValues={{
          invoiceID: searchParams.get('invoiceID') || '',
          invoiceStartDate: searchParams.get('invoiceStartDate') || '',
          invoiceEndDate: searchParams.get('invoiceEndDate') || '',
          invoiceDueStartDate: searchParams.get('invoiceDueStartDate') || '',
          invoiceDueEndDate: searchParams.get('invoiceDueEndDate') || '',
        }}
        onSubmit={() => {}}
      >
        <Form as={Row}>
          <Col md={3}>
            <InvoicesFilter
              searchParams={searchParams}
              setSearchParams={setSearchParams}
            />
          </Col>
          <Col md={9}>
            <InvoicesTable
              useData={billingApi.useGetUserInvoicesQuery}
              searchParams={searchParams}
            />
          </Col>
        </Form>
      </Formik>
    </>
  );
};
